<template>
  <div class="mt-3">
    <div class="sub-title">{{ panelCount }} panelen</div>

    <div class="card card-body">
      <div class="row">
        <div class="col-md-13">
          <template v-if="loadingQuotationDetails">
            <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
          </template>
          <template v-else>
            <template v-if="quotationDetails">
              <div class="material-price grayed-price">
                Prijs panelen
                <div class="price-value">
                  {{ quotationDetails.price | price }}
                </div>
              </div>
              <div class="transport-price grayed-price">
                Transportkosten
                <div class="price-value">
                  {{ quotationDetails.deliveryPrice | price }}
                </div>
              </div>

              <div class="total-price mt-1">
                Totaalprijs (ex. BTW)
                <div class="price-value">
                  {{ totalPrice | price }}
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      loadingQuotationDetails() {
        return this.$store.getters.loadingQuotationDetails
      },
      quotationDetails() {
        return this.$store.getters.quotationDetails
      },
      panelCount() {
        return this.$store.getters.totalPanelCount
      },
      totalPrice() {
        if (this.quotationDetails) {
          return this.quotationDetails.price + this.quotationDetails.deliveryPrice
        }
        return null
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
